module.exports = __webpack_public_path__ + "img/apartment_active.66fcaa2c.svg";